/*
 * MAGNUM HOME & WINE – Weiterlesen + Einblenden für sections/magnum-story.liquid
 * Ausgelagert 07.10.2026: Die Section steht auf Weinseiten zweimal (Winzer + Herkunft),
 * das Skript stand dadurch zweimal im HTML. Als Modul lädt und läuft es nur einmal,
 * auch wenn der <script>-Tag zweimal vorkommt.
 */
(function () {
  if (window.__mgnStory) { window.__mgnStory(); return; }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = (!reduced && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.2 }) : null;

  window.__mgnStory = function () {
    document.querySelectorAll('[data-mgn-story]:not([data-mgn-init])').forEach(function (panel) {
      panel.setAttribute('data-mgn-init', '');
      if (io) {
        var r = panel.getBoundingClientRect();
        var visible = r.top < window.innerHeight * 0.8 && r.bottom > 0;
        if (!visible) { panel.classList.add('mgn-story--anim'); io.observe(panel); }
      }
      var text = panel.querySelector('[data-mgn-story-text]');
      var btn = panel.querySelector('[data-mgn-story-more]');
      if (!text || !btn) return;
      text.classList.add('is-clamped');
      var lh = parseFloat(getComputedStyle(text).lineHeight) || 26;
      if (text.scrollHeight - text.clientHeight > lh * 4) {
        btn.hidden = false;
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          text.classList.toggle('is-clamped', open);
          if (open) { text.closest('[data-mgn-story]').scrollIntoView({ block: 'nearest' }); }
        });
      } else {
        text.classList.remove('is-clamped');
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.__mgnStory);
  } else {
    window.__mgnStory();
  }
  document.addEventListener('shopify:section:load', function () { window.__mgnStory(); });
})();
